import { CardAction } from "@/components/shared/card-action";
import { ListHeading } from "@/components/shared/list-header";
import { View, Button, Input } from "@/components/ui";
import { MapPinPlus } from "@/components/shared/icons";
import type { Control } from "react-hook-form";
import { InputFormControl } from "@/components/shared/input-form-control";
import { Spin } from "@/components/shared/spin";
import type { Address } from "@/types/users";
import { getAddressDisplay } from "@/containers/booking-info/booking-info-form";

export const ServiceAddressSection = ({
  chosenAddress,
  isLoggedIn,
  control,
  loading,
  onSearchPostalCode,
  onChangeAddress,
  getAddressByPostalCode,
}: {
  chosenAddress: Address | undefined;
  isLoggedIn: boolean;
  loading: boolean;
  control: Control<{ postalCode: string }>;
  getAddressByPostalCode(): void;
  onSearchPostalCode(): void;
  onChangeAddress(): void;
}) => {
  const chosenAddressDisplay = getAddressDisplay(chosenAddress);

  return (
    <View className="flex w-full flex-col px-4">
      <ListHeading title="Service Address" icon={MapPinPlus} />
      {isLoggedIn ? (
        <CardAction
          className="mt-6"
          label={
            chosenAddress ? chosenAddressDisplay.label || "" : "Select address"
          }
          body={
            chosenAddress
              ? chosenAddressDisplay.detailWithPostalCode
              : "Tap to choose or add a service address"
          }
          action={
            <Button
              variant="tertiary"
              color="CTA2"
              size="sm"
              rounded="full"
              className="p-0"
              onClick={onChangeAddress}
              children={chosenAddress ? "Change" : "Select"}
              iconName="caretRight"
              iconSize="sm"
              iconColor="foreground"
              iconAlignment="end"
            />
          }
        />
      ) : (
        <View className="mt-4 flex flex-row items-end gap-2">
          <InputFormControl
            label="Postal Code"
            name="postalCode"
            className="flex-1 pb-0"
            control={control}
            component={Input}
            componentProps={{
              placeholder: "Input your postal code",
              suffix: loading && <Spin />,
            }}
            changeFallBack={getAddressByPostalCode}
            rightRender={
              <Button
                variant="primary"
                color="CTA2-tertiary"
                onClick={onSearchPostalCode}
                children="Find Availability"
              />
            }
          />
        </View>
      )}
    </View>
  );
};
